import getApi from '../../api'
import { ResourceHistoryApi, ResourceHistoryMutationPayload } from './mapper'

export const createResourceHistory = (resourceHistory: ResourceHistoryMutationPayload) =>
  getApi().post<ResourceHistoryApi>('/resources/history', resourceHistory)
